export default __webpack_public_path__ + "static/media/img_muslinTwoEars_rg.210bed1a.jpg";